export default "__VITE_ASSET__BIR5OITl__"